import { call, put, takeLatest, select } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { submitReportApi } from '../../api/apiLists/reportApi';
import { showAlert } from '../alertSlice';
import { uploadFileToS3 } from './fileUploadHelper';
import {
  submitReportRequest,
  submitReportSuccess,
  submitReportFailure,
  closeReportDialog,
} from '../reportSlice';

function* handleSubmitReport(action) {
  try {
    const { issueTitle, details, file } = action.payload;
    const companyId = yield select(state => state.auth?.user?.companyId || state.auth?.companyId);

    let attachment = null;

    if (file) {
      try {
        attachment = yield call(uploadFileToS3, file, companyId, 'bug-report');
      } catch (fileError) {
        const errorMsg = fileError?.message || 'Failed to upload attachment. Please try again.';
        yield put(submitReportFailure(errorMsg));
        yield put(showAlert({
          message: errorMsg,
          type: 'error'
        }));
        return;
      }
    }

    const reportData = {
      issueTitle,
      details,
      attachment
    };

    const res = yield call(callWithAuth, submitReportApi, reportData);

    if (res?.status === true) {
      yield put(submitReportSuccess());
      yield put(showAlert({
        message: res.msg || "Your report has been submitted successfully. Thank you for helping us improve!",
        type: 'success'
      }));
      yield put(closeReportDialog());
    } else {
      const errorMsg = res?.msg || res?.errMsg || 'Error submitting report. Please try again.';
      yield put(submitReportFailure(errorMsg));
      yield put(showAlert({
        message: errorMsg,
        type: 'error'
      }));
    }
  } catch (error) {
    const errorMsg = error?.message || 'An error occurred while submitting your report.';
    yield put(submitReportFailure(errorMsg));
    yield put(showAlert({
      message: errorMsg,
      type: 'error'
    }));
  }
}

function* reportSaga() {
  yield takeLatest(submitReportRequest.type, handleSubmitReport);
}

export default reportSaga;
